export class NotificationUtils {
    static getNotificationIcon(type: string): { icon: string; iconClass: string } {
        if (!type) {
            return { icon: 'bell', iconClass: 'general' };
        }

        const typeMap: { [key: string]: { icon: string; iconClass: string } } = {
            'new_contact_request': { icon: 'user', iconClass: 'contact' },
            'new_quote_request': { icon: 'file-invoice', iconClass: 'quote' },
            'quote_interest': { icon: 'file-invoice', iconClass: 'quote-interest' },
            'billing': { icon: 'credit-card', iconClass: 'billing' },
            'new_review': { icon: 'star', iconClass: 'review' },
            'appointment': { icon: 'calendar-event', iconClass: 'appointment' },
            'payment': { icon: 'cash', iconClass: 'payment' },
            'system': { icon: 'settings', iconClass: 'system' },
            'general': { icon: 'bell', iconClass: 'general' },
            'partner_updated': { icon: 'edit', iconClass: 'partner-update' },
            'partner_created': { icon: 'building-community', iconClass: 'partner-new' },
        };

        return typeMap[type.toLowerCase()] || typeMap['general'];
    }
}